import React from 'react';

import ConsentCategorySelect from '../ConsentCategorySelect';
import useConsentCategorySelectEnabled from './useConsentCategorySelectEnabled';

export default function GatedConsentCategorySelect(props) {
  const { consentCategorySelectEnabled } = useConsentCategorySelectEnabled();

  // no fallback
  if (!consentCategorySelectEnabled) {
    return null;
  }

  return <ConsentCategorySelect {...props} />;
}

GatedConsentCategorySelect.propTypes = ConsentCategorySelect.propTypes;
